import type React from 'react'
import type { JSX } from 'react'
import type { COLOR, FIXED_INDENTS, LAYOUT, NAVBAR_HEIGHT } from 'vars/index'
import type { PositioningBlockPosition } from './PositioningBlock.h'

import { PositioningBlockSC } from './PositioningBlock.styled'

export interface IPositioningBlockProps {
  children: React.ReactNode
  position?: PositioningBlockPosition
  top?: number | string | NAVBAR_HEIGHT
  zIndex?: number
  backgroundColor?: COLOR
  paddings?: Array<FIXED_INDENTS | LAYOUT>
}

export const PositioningBlock = ({
  children,
  position,
  top,
  zIndex,
  backgroundColor,
  paddings,
}: IPositioningBlockProps): JSX.Element => (
  <PositioningBlockSC
    position={position}
    top={top}
    zIndex={zIndex}
    backgroundColor={backgroundColor}
    paddings={paddings}
  >
    {children}
  </PositioningBlockSC>
)
